var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 13.6673C8.65075 13.6673 11.3334 12.7513 11.3334 11.0007V3.00065C11.3334 1.24998 8.65075 0.333984 6.00008 0.333984C3.34941 0.333984 0.666748 1.24998 0.666748 3.00065V11.0007C0.666748 12.7513 3.34941 13.6673 6.00008 13.6673ZM6.00008 12.334C3.51875 12.334 2.00008 11.4707 2.00008 11.0007V10.1553C3.02741 10.714 4.51808 11.0007 6.00008 11.0007C7.48208 11.0007 8.97275 10.714 10.0001 10.1553V11.0007C10.0001 11.4707 8.48141 12.334 6.00008 12.334ZM6.00008 1.66732C8.48141 1.66732 10.0001 2.53065 10.0001 3.00065C10.0001 3.47065 8.48141 4.33398 6.00008 4.33398C3.51875 4.33398 2.00008 3.47065 2.00008 3.00065C2.00008 2.53065 3.51875 1.66732 6.00008 1.66732ZM2.00008 4.82198C3.02741 5.38065 4.51808 5.66732 6.00008 5.66732C7.48208 5.66732 8.97275 5.38065 10.0001 4.82198V5.66732C10.0001 6.13732 8.48141 7.00065 6.00008 7.00065C3.51875 7.00065 2.00008 6.13732 2.00008 5.66732V4.82198ZM2.00008 7.48865C3.02741 8.04732 4.51808 8.33398 6.00008 8.33398C7.48208 8.33398 8.97275 8.04732 10.0001 7.48865V8.33398C10.0001 8.80398 8.48141 9.66732 6.00008 9.66732C3.51875 9.66732 2.00008 8.80398 2.00008 8.33398V7.48865Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOil);
export default __webpack_public_path__ + "static/media/oil.ab9627ddcc799c5a3ee02b6aeb9e17e9.svg";
export { ForwardRef as ReactComponent };